export const APPLY_FOR_FINANCING_LABEL = `Apply for financing`
export const REOPEN_APPLICATION_LABEL = `Reopen application`
export const MARK_APPROVED_LABEL = `Mark Approved`
export const MARK_APPROVED_CONFIRM_PROMPT = `Confirm the application was approved in Credit Human. Vision will record this as a manual approval.`
export const MARK_APPROVED_CONFIRM_LABEL = `Confirm approval`
export const MARK_APPROVED_CANCEL_LABEL = `Cancel`
export const REPLACE_APPLICATION_LABEL = `Replace application`
export const CONFIRM_REPLACE_APPLICATION_LABEL = `Confirm replace`
export const CANCEL_REPLACE_APPLICATION_LABEL = `Cancel`
export const PREVIOUS_APPLICATIONS_HEADING = `Previous applications`
export const FINANCING_CHANGED_LABEL = `Financing changed`
export const APPLICATION_ACTIVITY_HEADING = `Activity`

const APPLICATION_STATUS_LABEL: Record<string, string> = {
  incomplete: `Incomplete`,
  applied: `Applied`,
  denied: `Denied`,
  approved_with_stipulations: `Approved with stipulations`,
  approved: `Approved`,
  loan_docs_sent: `Loan documents sent`,
  signed: `Signed`,
  cancelled: `Cancelled`,
}

export const applicationStatusLabel = (status: string): string =>
  APPLICATION_STATUS_LABEL[status] ?? status.replaceAll(`_`, ` `)
